import { ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { techPartnerOffer } from "@/lib/commercial-content";
import { trackTechPartnerClick } from "@/lib/analytics";

const TechPartnerPage = () => (
  <main id="main-content" className="bg-[#0a0a0a] pt-24">
    <section className="relative overflow-hidden bg-[#0a0a0a] py-20 md:py-28">
      <div className="absolute inset-0 dot-pattern opacity-10 pointer-events-none" />
      <div className="max-w-[1400px] mx-auto px-5 sm:px-8 relative">
        <div className="grid grid-cols-1 lg:grid-cols-[minmax(0,1fr)_420px] gap-8 lg:gap-12 items-start">
          <div>
            <div className="inline-block bg-[#ff6b35] text-[#0a0a0a] px-3 py-1 brutal-border font-mono text-xs uppercase tracking-widest mb-5">
              Acompanhamento recorrente
            </div>
            <h1 className="font-display text-white text-[2.65rem] min-[380px]:text-5xl sm:text-7xl lg:text-8xl uppercase leading-[0.9]">
              {techPartnerOffer.name}
            </h1>
            <p className="mt-6 max-w-3xl text-white/75 text-lg sm:text-xl leading-snug">
              {techPartnerOffer.summary}
            </p>
            <Link
              to="/contacto"
              onClick={() => trackTechPartnerClick("tech_partner_page")}
              className="btn-brutal btn-brutal-orange mt-8 inline-flex"
            >
              <span>Quero um parceiro tecnológico</span>
              <ArrowRight size={18} className="shrink-0" />
            </Link>
          </div>

          <aside className="brutal-card bg-white p-6 sm:p-8">
            <p className="font-mono text-xs uppercase tracking-widest text-[#ff6b35] mb-3">
              Investimento
            </p>
            <p className="font-display text-[#0a0a0a] text-5xl uppercase leading-none">
              {techPartnerOffer.price}
            </p>
            <p className="mt-4 bg-[#0a0a0a] text-white brutal-border px-4 py-3 font-mono text-xs uppercase tracking-widest">
              Hora adicional: {techPartnerOffer.additionalHour}
            </p>
          </aside>
        </div>

        <div className="mt-14 sm:mt-16 grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-5 gap-4">
          {techPartnerOffer.includes.map((item) => (
            <div key={item} className="bg-[#ff6b35] brutal-border p-4 min-h-[120px] flex items-end">
              <p className="font-display text-[#0a0a0a] text-2xl uppercase leading-none">{item}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  </main>
);

export default TechPartnerPage;
